import createVueComponent from '../createVueComponent';

const ArrowDown10 = createVueComponent('ArrowDown10Icon', [
  ['path', { d: 'm3 16 4 4 4-4', key: '1co6wj' }],
  ['path', { d: 'M7 20V4', key: '1yoxec' }],
  ['path', { d: 'M17 10V4h-2', key: 'zcsr5x' }],
  ['path', { d: 'M15 10h4', key: 'id2lce' }],
  [
    'rect',
    { x: '15', y: '14', width: '4', height: '6', ry: '2', key: '33xykx' },
  ],
]);

export default ArrowDown10;
